import { FormSelectRole, IDynamicFormRow } from '@src/components';
import { User } from '@src/services/users/usersTypes';
import { HiPlus } from 'react-icons/hi2';
type UserChangeRoleSchemaProps = {
    t: (key: string, options?: Record<string, any>) => string;
    addNewRole?: () => void;
    user?: User | null;
};

export function UserChangeRoleSchema({
    t,
    addNewRole,
    user,
}: UserChangeRoleSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: '',
            keyName: 'email',
            Component: () => (
                <div className="flex flex-col gap-2 text-base">
                    <span className="font-normal">{t('forms.email')}</span>
                    <span className="font-medium text-primary">
                        {user?.email}
                    </span>
                </div>
            ),
        },
        {
            label: t('forms.role'),
            keyName: 'role',
            Component: FormSelectRole,
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.role'),
                    }),
                },
            },
            formProps: {
                customOption: {
                    label: (
                        <span
                            className="text-primary flex gap-2 items-center"
                            onClick={addNewRole}
                        >
                            <HiPlus size={16} />
                            {t('pages.users.forms.createNewRole')}
                        </span>
                    ),
                    value: 'custom',
                },
                size: 'large',
                requireAccountId: true,
                accountId: user?.accountId,
            },
        },
    ];
}
